var RegionsMap = new Class({
	Extends: SimpleMap,
	Implements: [Options, Events],

	options: {
		custom_polygons: [
			{ // Central park
				points: [
					[-73.973039,40.764405],
					[-73.981783,40.76807],
					[-73.958126,40.800572],
					[-73.949329,40.796877],
					[-73.973039,40.764405]
				],
				config: {
					strokeColor: "#fff",
					strokeWeight: 0,
					fillColor: "#89d651",
					fillOpacity: 0.7
				}
			}
		],

		restrict: {
			sw: {
				lat: 40.68,
				lng: -74.06
			},

			ne: {
				lat: 40.83,
				lng: -73.91
			}
		},

		polygon_idle: {
			strokeOpacity: 1,
			strokeWeight: 1,
			fillColor: "#777",
			fillOpacity: 0
		},
		polygon_hover: {
			strokeWeight: 1,
			fillColor: "#c0f5fd",
			fillOpacity: 1
		},
		polygon_selected: {
			strokeWeight: 1,
			fillOpacity: 1,
			fillColor: '#c0f5fd'
		},
		polygon_deselected: {
			strokeWeight: 1,
			fillOpacity: 0,
			fillColor: '#777'
		},

		bubble: {},

		center_bubble: false,
		keep_bubble_open: false,

		lat: 40.749293,
		lng: -74.005966,
		zoom: 12,
		max_zoom: 12,
		min_zoom: 12,
		scrollwheel: false,
		zoom_control: false,
		draggable: true,
		disableDoubleClickZoom: true,
		style: 'dark',

		map_styles: {
			'dark': [
				{
					"stylers": [
						{ "saturation": -100 },
						{ "visibility": "off" },
						{ "gamma": 1.20 },
						{ "lightness": -59 }
					]
				},{
					"featureType": "water",
					"stylers": [
						{ "visibility": "on" }
					]
				},{
					"elementType": "labels",
					"stylers": [
						{ "visibility": "off" }
					]
				},{
					"elementType": "geometry.stroke",
					"stylers": [
						{ "visibility": "off" }
					]
				},{
					"featureType": "landscape.natural",
					"stylers": [
						{ "visibility": "simplified" },
						{ "lightness": 15 }
					]
				}
			],

			'light': [
				{
					"stylers": [
						{ "saturation": -100 },
						{ "visibility": "off" },
						{ "gamma": 1.20 },
						{ "lightness": 150 }
					]
				},{
					"featureType": "water",
					"stylers": [
						{ "visibility": "on" }
					]
				},{
					"elementType": "labels",
					"stylers": [
						{ "visibility": "off" }
					]
				},{
					"elementType": "geometry.stroke",
					"stylers": [
						{ "visibility": "off" }
					]
				},{
					"featureType": "landscape.natural",
					"stylers": [
						{ "visibility": "simplified" },
						{ "lightness": -15 }
					]
				}
			]
		}
	},

	build: function(){
		this.points = [];

		var self = this;
		var opts = this.options;

		if(opts.style == 'dark'){
			opts.map_styles = opts.map_styles.dark;
			opts.polygon_idle.strokeColor = '#999';
		}else{
			opts.map_styles = opts.map_styles.light;
			opts.polygon_idle.strokeColor = '#fff';
		}

		this.addEvent('mapReady', function(){
			if(opts.custom_polygons){
				self.add_custom_polygons();
			}
			self.set_zones();
			self.restrict_pan();
		});

		this.parent();
	},

	set_region: function(name, coordinates, fn, selected, extra){
		if(!coordinates || typeOf(coordinates) != 'array' || coordinates.length < 3) return null;

		extra = extra || {};
		var coords = [];

		var most_top_corner_lat,
				most_bottom_corner_lat,
				most_top_corner_latlng,
				most_bottom_corner_latlng,
				center_lat = 0,
				center_lng = 0,
				center_latlng;

		var opts = this.options;

		var i = 0;

		coordinates.each(function(el){
			if(el[0] && el[1]){
				var latlng = new google.maps.LatLng(el[1], el[0]);
				coords.push(latlng);

				if(!most_top_corner_lat || el[1] > most_top_corner_lat){
					most_top_corner_lat = el[1];
					most_top_corner_latlng = latlng;
				}

				if(!most_bottom_corner_lat || el[1] < most_bottom_corner_lat){
					most_bottom_corner_lat = el[1];
					most_bottom_corner_latlng = latlng;
				}

				center_lat += el[1];
				center_lng += el[0];
				i++;
			}
		});

		center_lat /= i;
		center_lng /= i;

		center_latlng = new google.maps.LatLng(center_lat, center_lng);

		this.points.push(center_latlng);

		if(coords.length < 3) return null;

		var self = this;
		var bubble;

		if(name && name != ''){
			var bubble_options = Object.merge({
				content: name
			}, opts.bubble);

			bubble = new SimpleMap.Bubble(this.map, most_top_corner_latlng, bubble_options);
		}

		var idle_options = Object.merge({
			paths: coords
		},opts.polygon_idle);

		var region = new google.maps.Polygon(idle_options);

		region.bubble = bubble;

		if(bubble){
			var _bubble;

			var __adjust_bubble = function(){ return;
				bubble.infobox.set_position(most_top_corner_latlng);

				if(self._element.getPosition().y + 50 > _bubble.getPosition().y){
					bubble.infobox.set_position(center_latlng);
				}

				if(self._element.getPosition().y + 50 > _bubble.getPosition().y){
					bubble.infobox.set_position(most_bottom_corner_latlng);
				}
			}

			bubble.addEvents({
	      'bubbleOpen': function(){
					// if(self.selected_region_bubble){
					// 	self.selected_region_bubble.close();
					// }

					if(opts.center_bubble){
						self.infobox.set_position(center_latlng);
						return;
					}

					self.selected_region_bubble = bubble;

					if(_bubble){
						__adjust_bubble();
					}
	      },

	      'bubbleReady': function(el){
	        if(el == _bubble) return;

	        _bubble = el;
	      }
	    });
		}

		if(selected){
			this.select_region(region);
			region.selected = true;
		}else{
			region.selected = false;
		}

		region.setMap(this.map);

		google.maps.event.addListener(region,
			'click', function(){
				if(fn && typeOf(fn)=='function'){
					fn(name, extra);
				}
			}
		);

		google.maps.event.addListener(region, 'mouseover', function(){
			if(!region.selected){
				region.setOptions(opts.polygon_hover);

				// if(self.selected_region_bubble && !opts.keep_bubble_open){
				// 	self.selected_region_bubble.close();
				// }

				// self.selected_region_bubble = bubble;
			}

			if(bubble){
				bubble.open();
			}
		});

		google.maps.event.addListener(region,	'mouseout', function(){
			if(region.selected){
				region.setOptions(opts.polygon_selected);
			}else{
				region.setOptions(opts.polygon_idle);
			}

			if(bubble && !opts.keep_bubble_open){
				bubble.close();
			}
		});

		if(bubble && opts.keep_bubble_open){
			bubble.open();
		}

		return region;
	},

	set_zones: function(){
		if(this._element.getSize().x == 0) return; //if element is not visible

		var _zones = this._element.getParent().getElement('.map_config .zones') || document.getElement('.footer .map_config .zones');
		if(!_zones) return;

		var zones;

		try{
			zones = JSONMOO.decode(_zones.get('html'), false);
		}catch(e){
			return;
		}

		Object.each(zones, function(el){
			this.add_marker({
				lat: el[0],
				lng: el[1],
				label: {
					content: el[2],
					add_class: el[3] + (this.options.style == 'dark'? '' : ' _red')
				},
				icon: Res_i + '/l/dummy.png'
			});
		}.bind(this));
	},

	select_region: function(region){
		region.setOptions(this.options.polygon_selected);

		region.selected = true;
	},

	deselect_region: function(region){ //used outside of the class
		region.setOptions(this.options.polygon_deselected);

		region.selected = false;
	},

	add_custom_polygons: function(){
		this.options.custom_polygons.each(function(el){
			var paths = [];

			el.points.each(function(point) {
				paths.push(new google.maps.LatLng(point[1], point[0]));
			});

			var copts = Object.merge({
				paths: paths
			}, el.config);

			var poly = new google.maps.Polygon(copts);
			poly.setMap(this.map);
		}.bind(this));
	},

	restrict_pan: function(){
		var opts = this.options;
		var map = this.map;

		if(!opts.restrict) return;

		var allowed_bounds = new google.maps.LatLngBounds(
			new google.maps.LatLng(opts.restrict.sw.lat, opts.restrict.sw.lng),
			new google.maps.LatLng(opts.restrict.ne.lat, opts.restrict.ne.lng)
		);

		var last_valid_center = map.getCenter();

		google.maps.event.addListener(map, 'center_changed', function(){
			if(allowed_bounds.contains(map.getCenter())){
				last_valid_center = map.getCenter();
				return;
			}

			if(last_valid_center){
				map.panTo(last_valid_center);
			}
		});
	}
});
